import React from "react";
import {Mutation} from "react-apollo";
import StatusTag from "../../components/StatusTag";
import ActionButton from "../../components/ActionButton";

// Whether the destination of a stock transfer or purchase order has been sent
// a shipment advice. The advice itself is sent by hand; this only records it.

function formatWhen(at) {
  return at ? String(at).substr(0, 16).replace("T", " ") : "";
}

// "Sent 2026-10-23 14:02 by …" or "Not sent".
export function adviceSentText(document) {
  if (!document || !document.adviceSent) return "Not sent";
  const by = document.adviceSentBy ? ` by ${document.adviceSentBy}` : "";
  return `Sent ${formatWhen(document.adviceSentAt)}${by}`;
}

// The small "SA" tag after a status in the lists: green once sent, orange
// while the document is open (`open`) and nobody has sent it yet. Nothing
// for a closed document that was never sent one.
export const AdviceTag = ({sent, sentAt, open}) => {
  if (sent) {
    return <StatusTag color={StatusTag.COLORS.GREEN} text="SA" noMargin title={`Shipment advice sent ${formatWhen(sentAt)}`} />
  }
  if (open) {
    return <StatusTag color={StatusTag.COLORS.ORANGE} text="SA" noMargin title="Shipment advice not sent yet" />
  }
  return null;
};

// The Actions panel button that marks the advice sent, or takes that back.
// `mutation` takes `$data` with `sent`; `input` is the rest of its input.
export const AdviceSentButton = ({mutation, resultField, input, sent, active}) => (
  <Mutation mutation={mutation}>
    {(mutate, {loading}) => (
      <ActionButton
        label={sent ? "Unmark Advice Sent" : "Mark Advice Sent"}
        active={active && !loading}
        onClick={() => mutate({variables: {data: {...input, sent: !sent}}}).then((response) => {
          const errors = response.data[resultField].errors;
          if (errors.length > 0) window.alert(errors.map((error) => error.message).join("\n"));
        })} />
    )}
  </Mutation>
);
